module.exports = __webpack_public_path__ + "img/zq.a930e32c.png";